import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { AppState } from '@/app/store';
import { Product } from '@/lib/types/bevmaq.types';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { BuyForm } from '../../Form/BuyForm';
import { SuccessCheck } from '../../Form/SuccessCheck';
import { setIsOpen } from './buyModalSlice';

export function BuyFormModal({ product }: { product: Product }) {
  const { t } = useTranslation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const isOpen = useAppSelector((state: AppState) => state.buyModal.isOpen);
  const dispatch = useAppDispatch();
  const { asPath } = useRouter();
  function handleSetIsOpen(open: boolean) {
    dispatch(setIsOpen(open));
  }
  useEffect(() => setIsSubmitted(false), [asPath]);
  return (
    <div className='text-center md:text-left'>
      <div
        className='inline-block w-full cursor-pointer rounded bg-orange-400 px-8 py-4 text-center font-bold text-white hover:bg-orange-500'
        data-testid='btn-buy-modal'
        onClick={() => {
          handleSetIsOpen(!isOpen);
        }}
      >
        {t('common:Get an official quote')}
      </div>
      <input type='checkbox' id='buy-modal' className='modal-toggle' />
      <div
        className={classNames({
          modal: true,
          'modal-open': isOpen,
        })}
        onClick={() => handleSetIsOpen(false)}
      >
        <div
          className='modal-box relative max-w-4xl'
          onClick={(e) => e.stopPropagation()}
        >
          <label
            className='btn btn-circle btn-sm absolute right-2 top-2 bg-primary text-white'
            onClick={() => handleSetIsOpen(false)}
          >
            ✕
          </label>

          {!isSubmitted ? (
            <>
              <h3 className='title mb-4' data-test-id='buy-modal-title'>
                {t('common:Get an official quote')}
              </h3>
              <p className='subtitle py-4'>
                {t(
                  'common:Fill in the information below to receive an official quote on the machine you have selected'
                )}
              </p>
              <BuyForm setIsSubmitted={setIsSubmitted} product={product} />
            </>
          ) : (
            <SuccessCheck
              message={t(
                'common:thanks-we-will-contact-you-as-soon-as-possible'
              )}
            />
          )}
        </div>
      </div>
    </div>
  );
}
